import type { OrderedMaterialLine } from "@/lib/projectOverview";
import { orderTextWithArticleNumber } from "@/lib/orderDraftUtils";

function formatQty(value: number | string | null | undefined): string | null {
  if (value == null || value === "") return null;
  const n = typeof value === "number" ? value : Number(String(value).replace(",", "."));
  if (!Number.isFinite(n)) return String(value).trim() || null;
  return new Intl.NumberFormat("de-DE", { maximumFractionDigits: 4 }).format(n);
}

/** Anzahl, Einheit und Bezeichnung für eine Bestellzeile (API liefert teils nur `label`). */
export function orderLineDisplay(line: OrderedMaterialLine): {
  qty: string | null;
  unit: string | null;
  title: string;
} {
  const qty = formatQty(line.menge ?? line.default_menge);
  const unit = String(line.einheit || "").trim() || null;
  let title = String(line.text || "").trim();

  if (!title && line.label) {
    const raw = String(line.label).trim();
    const sep = raw.indexOf(" · ");
    if (sep >= 0) {
      title = raw.slice(sep + 3).trim();
    } else {
      title = raw;
    }
  }

  if (!title) title = "Artikel";
  title = orderTextWithArticleNumber(title, line.hero_nr);

  return { qty, unit, title };
}
